let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("22aS6")).then(() => parcelRequire('48wUg'));